(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import PropTypes from 'prop-types';

function ImageWebp({
  src,
  mobilesrc,
  webp,
  type = 'image/webp',
  ...delegated
}) {
  let webpSrc = webp;
  let webpSrcMobile = webp;
  let mobilePic;

  if (!webp) {
    webpSrc = src.replace(/\.(jpe?g|png)/i, '.webp');
  }

  if (mobilesrc != undefined) {
    webpSrcMobile = mobilesrc.replace(/\.(jpe?g|png)/i, '.webp');
    mobilePic = /*#__PURE__*/React.createElement("source", {
      media: "(max-width: 600px)",
      srcSet: webpSrcMobile,
      type: type
    });
  }

  return /*#__PURE__*/React.createElement("picture", null, mobilePic, /*#__PURE__*/React.createElement("source", {
    srcSet: webpSrc,
    type: type
  }), /*#__PURE__*/React.createElement("img", _extends({
    src: src
  }, delegated)));
}

ImageWebp.propTypes = {
  src: PropTypes.string,
  mobilesrc: PropTypes.string,
  webp: PropTypes.string,
  type: PropTypes.string
};
const _default = ImageWebp;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ImageWebp, "ImageWebp", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/custom/ImageWebp.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/custom/ImageWebp.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();